import * as React from "react";
import { FieldRenderProps, FieldWrapper } from "@progress/kendo-react-form";
import {
  InputSuffix,
  // NumericTextBox,
  TextBox,
  TextBoxProps,
} from "@progress/kendo-react-inputs";
import {
  // FloatingLabel,
  Hint,
  Error,
  Label,
} from "@progress/kendo-react-labels";
import { checkIcon, warningTriangleIcon } from "@progress/kendo-svg-icons";
import { Button } from "@progress/kendo-react-buttons";

const FormTextField = (props: TextBoxProps & FieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    type = "text",
    optional,
    placeholder,
    wrapperClassName,
    max,
    onBlur,
    ...other
  } = props;

  const showValidationMessage = touched && validationMessage;
  const showHint = !showValidationMessage && hint;
  const hintId = showHint ? `${id}_hint` : "";
  const errorId = showValidationMessage ? `${id}_error` : "";

  return (
    <FieldWrapper className={wrapperClassName}>
      <Label
        // label={label}
        editorId={id}
        // editorValue={other.value}
        editorValid={valid}
        editorDisabled={disabled}
        optional={optional}
      >
        {label}
      </Label>
      {/* {type === "number" ? (
          <NumericTextBox
            ariaDescribedBy={`${hintId} ${errorId}`}
            valid={valid}
            id={id}
            disabled={disabled}
            
            // onChange={handleInputChange}
            defaultValue={isNaN(defaultValue) ? null : defaultValue}
            step={typeof step === "number" ? step : undefined}
            min={typeof min === "number" ? min : undefined}
            max={typeof max === "number" ? max : undefined}
            {...other}
          />
        ) : ( */}
      <TextBox
        valid={valid}
        rounded={"large"}
        type={type}
        size={"large"}
        placeholder={placeholder}
        suffix={() =>
          touched ? (
            <InputSuffix>
              {valid ? (
                <Button
                  themeColor={"success"}
                  fillMode={"flat"}
                  svgIcon={checkIcon}
                />
              ) : (
                <Button
                  themeColor={"error"}
                  fillMode={"flat"}
                  svgIcon={warningTriangleIcon}
                />
              )}
            </InputSuffix>
          ) : null
        }
        onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
          if (max) {
            return (e.target.value = Math.max(0, parseInt(e.target.value))
              .toString()
              .slice(0, +max));
          } else {
            return e;
          }
        }}
        id={id}
        disabled={disabled}
        aria-describedby={`${hintId} ${errorId}`}
        onBlur={onBlur}
        {...other}
      />
      {/* )} */}
      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  );
};

export default FormTextField;
